import React from "react";
import { ContentContainer, PageHeader, astryx } from "@shadowcue/ui";

export interface IUserForm {
  id?: number;
  email: string;
  password: string;
  passwordConfirm: string;
  admin: boolean;
}

interface UserFormProps {
  values: IUserForm;
  onChange: (values: IUserForm) => void;
  loading?: boolean;
  isEditing?: boolean;
}

const UserForm = ({
  values,
  onChange,
  loading = false,
  isEditing = false,
}: UserFormProps) => {
  const updateField = (field: keyof IUserForm, value: string | boolean) => {
    onChange({ ...values, [field]: value });
  };

  return (
    <ContentContainer loading={loading}>
      <PageHeader
        title={isEditing ? "Edit user" : "New user"}
        description={
          isEditing
            ? "Update user account details."
            : "Create a new user account."
        }
      />

      <astryx.VStack gap={4}>
        <astryx.TextInput
          label="Email"
          type="email"
          isRequired
          value={values.email}
          onChange={(value: string) => updateField("email", value)}
          placeholder="user@example.com"
          width="100%"
        />

        <astryx.TextInput
          label="Password"
          type="password"
          isRequired={!isEditing}
          isOptional={isEditing}
          value={values.password}
          onChange={(value: string) => updateField("password", value)}
          placeholder={
            isEditing ? "Leave blank to keep current password" : "Password"
          }
          width="100%"
        />
        <astryx.TextInput
          label="Confirm password"
          type="password"
          isRequired={!isEditing}
          isOptional={isEditing}
          value={values.passwordConfirm}
          onChange={(value: string) => updateField("passwordConfirm", value)}
          placeholder={
            isEditing ? "Leave blank to keep current password" : "Confirm password"
          }
          width="100%"
        />

        <astryx.CheckboxInput
          label="Admin"
          value={values.admin}
          onChange={(checked: boolean) => updateField("admin", checked)}
        />
      </astryx.VStack>
    </ContentContainer>
  );
};

export default UserForm;
